// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Bx7US","modalFooterButton":"ModalNotes_modalFooterButton__2K0nL"};